import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const UserListIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33268 6.16732C9.33268 4.32637 7.84028 2.83398 5.99935 2.83398C4.1584 2.83398 2.66602 4.32637 2.66602 6.16732C2.66602 8.00825 4.1584 9.50065 5.99935 9.50065C7.84028 9.50065 9.33268 8.00825 9.33268 6.16732Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6673 14.1667C10.6673 11.5893 8.57798 9.5 6.00065 9.5C3.42332 9.5 1.33398 11.5893 1.33398 14.1667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.334 7.16602H14.6673"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.334 9.16602H14.6673"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 11.166H14.6673"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
